import * as React from 'react'
import { NavLink } from 'react-router-dom'
import { match as RouterMatch } from 'react-router'
import { Location } from 'history'
import './YNavLink.scss'

export interface ILinkProps {
  to: string
  className?: string
  children?: any
  onMouseOver?(): void
  onClick?(): void
  // Custom match predicate. Forwarded to react-router's NavLink so the visual
  // active class AND the `aria-current="page"` attribute stay in sync when the
  // visual highlight needs to cover a broader path than the link's `to` (e.g.
  // /statistics/* highlights a link that points at /statistics/dashboard).
  isActive?: (match: RouterMatch | null, location: Location) => boolean
}

export class YNavLink extends React.Component<ILinkProps> {
  render() {
    const { children, className, isActive, ...rest } = this.props

    const BEM = () => {
      const list = ['link']

      if (className) {
        list.push(className)
      }

      return list.join(' ')
    }

    return (
      <NavLink
        className={(active) => BEM() + (active ? ' link-active' : '')}
        isActive={isActive}
        aria-current="page"
        {...rest}
      >
        {children}
      </NavLink>
    )
  }
}
